import React, { useRef } from 'react';
import useFaceCapture from '../hooks/useFaceCapture';

// PerformToggle — SPIKE (?face=1). Turns the webcam into a live driver for the
// resident's head pose (MediaPipe FaceLandmarker → faceBridge → AnimatedResident).
// Styled like the HUD music toggle; a tiny self-preview confirms the camera.
// Blendshapes are captured too (faceBridge.blend) for a future face rig.

const ON = typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('face') === '1';
const safe = (side, base) => `max(${base}px, env(safe-area-inset-${side}))`;

const btn = (live) => ({
  pointerEvents: 'auto', display: 'inline-flex', alignItems: 'center', gap: 8,
  background: 'rgba(20,12,6,0.65)', color: live ? '#ff8a9c' : '#ffd27d',
  border: `1px solid ${live ? 'rgba(255,94,120,0.6)' : 'rgba(255,178,94,0.35)'}`,
  borderRadius: 999, padding: '9px 14px', cursor: 'pointer', fontSize: 13.5,
  backdropFilter: 'blur(6px)', WebkitBackdropFilter: 'blur(6px)',
});

export default function PerformToggle() {
  const videoRef = useRef(null);
  const { status, error, start, stop } = useFaceCapture({ videoRef });
  if (!ON) return null;

  const live = status === 'live';
  const label = status === 'loading' ? 'Loading…' : status === 'live' ? '◼ Stop performing' : '🎭 Perform';

  return (
    <div style={{ position: 'fixed', left: safe('left', 16), top: `calc(${safe('top', 16)} + 52px)`, zIndex: 38, display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start' }}>
      <button style={btn(live)} onClick={live || status === 'loading' ? stop : start} disabled={status === 'loading'}>
        {label}
      </button>
      {error && <div style={{ color: '#ff9a9a', fontSize: 11.5, maxWidth: 220 }}>{error}</div>}
      {/* Small self-preview (mirrored) so the performer can frame themselves. */}
      <video
        ref={videoRef}
        muted
        playsInline
        style={{
          width: 128, height: 96, borderRadius: 10, objectFit: 'cover', transform: 'scaleX(-1)',
          border: '1px solid rgba(255,178,94,0.3)', background: '#000',
          opacity: live ? 0.9 : 0, pointerEvents: 'none', transition: 'opacity .2s',
        }}
      />
    </div>
  );
}
